import TemplateContents from './TemplateContents';
import { gsap } from 'gsap';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
  }

  setVars() {
    super.setVars();

    this.isOpenMenu = false;
  }

  setDom() {
    super.setDom();

    this.h2Dom = document.querySelector('header h2');
    this.grillDom = document.querySelector('header .grill_menu');
    this.menuDom = document.querySelector('header .menu');
    this.menuAnchorAll = document.querySelectorAll('header .menu .main_list li a');
    this.menuSocialAnchorAll = document.querySelectorAll('header .menu .social_list li a');
    this.globalNav = document.querySelector('header .global_nav');
    this.globalNavAnchorAll = document.querySelectorAll('header .global_nav .main_list li a');

    this.socialAnchorAll = document.querySelectorAll('header .global_nav .social_list li a');
  }

  initEvents() {
    super.initEvents();

    this.grillDom.addEventListener('click', (event) => {
      if(this.isOpenMenu){
        this.closeMenu();
      }else{
        this.openMenu();
      }
    });

    this.h2Dom.addEventListener('click', (event) => {
      this.pack.anchorScroll(0);
    });

    // アンカーリンクの共通処理
    const onAnchorClick = (e) => {
      const anchor = e.currentTarget;
      let href = anchor.getAttribute('href');

      // #で始まるリンクのみ対象（外部リンク等は除外）
      if (href && href.indexOf('#') === 0) {
        e.preventDefault();

        if (this.isOpenMenu) this.closeMenu();

        if (href === '#feature') href = '.intersection1';
        else if (href === '#products') href = '.intersection2';

        const target = document.querySelector(href);

        if (target) {
          const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
          this.pack.anchorScroll(targetTop);
        }
      }
    };

    this.globalNavAnchorAll.forEach((anchor) => anchor.addEventListener('click', onAnchorClick));
    this.menuAnchorAll.forEach((anchor) => {
      anchor.addEventListener('click', onAnchorClick);
      anchor.addEventListener('touchend', onAnchorClick);
    });

    // グローバルナビのホバーエフェクト
    this.globalNavAnchorAll.forEach((anchor) => {
      const spans = anchor.querySelectorAll('span.item');
      this.pack.applyTextHoverEffect(anchor, spans);
    });

    this.socialAnchorAll.forEach((anchor) => {
      this.pack.applyIconHoverEffect(anchor, anchor.querySelectorAll('span'));
    });
  }

  openMenu(){
    this.menuDom.classList.add('active');
    this.h2Dom.classList.add('white');
    this.grillDom.classList.add('close');

    requestAnimationFrame(()=>{
      this.menuDom.classList.add('open');

      for( let i = 0, len = this.menuAnchorAll.length; i < len; i++ ){
        let a = this.menuAnchorAll[i];
        a.style.animationDelay = .05 * i + 's';
        a.classList.add('show');
      }

      for( let i = 0, len = this.menuSocialAnchorAll.length; i < len; i++ ){
        let a = this.menuSocialAnchorAll[i];
        a.style.animationDelay = .3 + .05 * i + 's';
        a.classList.add('show');
      }
    });

    this.isOpenMenu = !this.isOpenMenu;
    this.pack.common.lockScroll = true;
    if (this.sw < this.pack.BP) document.documentElement.classList.add('lock');
  }

  closeMenu(){
    this.h2Dom.classList.remove('white');
    this.menuDom.classList.remove('open');
    this.grillDom.classList.remove('close');

    for( let i = 0, len = this.menuAnchorAll.length; i < len; i++ ){
      let a = this.menuAnchorAll[i];
      a.classList.remove('show');
    }

    for( let i = 0, len = this.menuSocialAnchorAll.length; i < len; i++ ){
      let a = this.menuSocialAnchorAll[i];
      a.classList.remove('show');
    }

    gsap.delayedCall(.5, ()=>{
      this.isOpenMenu = !this.isOpenMenu;
      this.menuDom.classList.remove('active');
      this.pack.common.lockScroll = false;
      if (this.sw < this.pack.BP) document.documentElement.classList.remove('lock');
    });
  }

  start() {
    this.globalNavAnchorAll.forEach((anchor) => {
      const spans = anchor.querySelectorAll('span.item');
      if (spans.length > 0) gsap.set(spans, { opacity: 0 });
    });

/*
    for( let i = 0, len = this.socialAnchorAll.length; i < len; i++ ){
      let item = this.socialAnchorAll[i];
      gsap.set(item, { opacity: 0 });
    }
*/

    gsap.delayedCall(4.5, ()=>{
      this.h2Dom.classList.add('show');
      let dr = .09;

      this.globalNavAnchorAll.forEach((anchor, id) => {
        const spans = anchor.querySelectorAll('span.item');
        if (spans.length === 0) return;

        spans.forEach((span) => {
          gsap.delayedCall(id * .15 + Math.random() * .2, ()=>{
            span.classList.add('show');
          });
        });
      });

      for( let i = 0, len = this.socialAnchorAll.length; i < len; i++ ){
        let item = this.socialAnchorAll[i];
        gsap.delayedCall(1 + i * .15, ()=>{
          item.classList.add('show');
        });

/*
        const tl = gsap.timeline();
        tl.to(item, { opacity: 1, duration: 0, delay: 1 + i * .15 })
            .to(item, {
              opacity: .3,
              duration: dr,
              repeat: 2,
              yoyo: true,
              ease: 'steps(1)'
            })
            .to(item, { opacity: 1, duration: dr });
*/
      }
    });
  }

  changeGlobalNavColor(isWhite){
    if(isWhite) this.globalNav.classList.add('white');
    else this.globalNav.classList.remove('white');
  }

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
